import type { MeasurementUnits } from "./CenterSettings/MeasurementUnitModel"


interface ValueWithMeasurementUnitMessageArg {
    units: string, 
    precision: number,
    value: number
}

class MeasurementUnitsConverter {
    private centerMeasurementUnits: MeasurementUnits | undefined

    setMeasurementUnits(units: MeasurementUnits) {
        this.centerMeasurementUnits = units
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formatServerResponse(message: string, extra: any): string {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (extra.message_args) {
            if (this.centerMeasurementUnits === undefined) {
                throw Error('Error formatting server response Center measurement units not set')
            } 
            const centerMeasurementUnits = this.centerMeasurementUnits
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            const messageArgs = (extra.message_args as Array<ValueWithMeasurementUnitMessageArg>)
            const unitReplacer = (_match: string, unitIndex: string): string => {
                const index = parseInt(unitIndex)
                const messageArg = messageArgs[index]
                if (messageArg === undefined) {
                    throw Error('Error formatting server response - number of message arguments do not match message string')
                }
                const { value, precision, units } = messageArg
                return `${centerMeasurementUnits.convertFromMetric(value, units).toFixed(precision)} ${centerMeasurementUnits.getMeasurementUnitName(units)}`
            }

            return message.replace(/{(\d)}/g, unitReplacer)
        } else {
            return message
        }
    }
}


export const MeasurementUnitsService = new MeasurementUnitsConverter()
